import { useCallback, useMemo, useState } from 'react';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIPopoverBody from 'UIComponents/tooltip/UIPopoverBody';
import UIPopoverCloseButton from 'UIComponents/tooltip/UIPopoverCloseButton';
import UITruncateString from 'UIComponents/text/UITruncateString';
import UIBox from 'UIComponents/layout/UIBox';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { TextArea } from 'foundations-components/transitional/components/TextArea';
import { getTransferrableProps } from '../../../utils/getTransferrableProps';
import { useProperty } from '../../../v2/hooks/useProperty';
import { usePropertyValue } from '../../../v2/hooks/usePropertyValue';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TextAreaPopover = props => {
  const {
    inputRef,
    onChange,
    popoverProps
  } = props;
  const [showPopover, setShowPopover] = useState(true);
  const property = useProperty();
  const value = usePropertyValue();
  const popoverContent = useMemo(() => {
    const handleChange = event => {
      return onChange(event);
    };
    return /*#__PURE__*/_jsxs(UIPopoverBody, {
      className: "p-bottom-5",
      children: [/*#__PURE__*/_jsxs(UIFlex, {
        justify: "between",
        children: [/*#__PURE__*/_jsx("b", {
          children: property.label
        }), /*#__PURE__*/_jsx(UIPopoverCloseButton, {
          onClick: () => setShowPopover(false)
        })]
      }), /*#__PURE__*/_jsx(UIBox, {
        className: "m-top-2",
        children: /*#__PURE__*/_jsx(TextArea, Object.assign({}, getTransferrableProps(props), {
          value: value === null ? '' : value,
          inputRef: inputRef,
          onChange: handleChange,
          styled: true,
          rows: 6
        }))
      })]
    });
  }, [property.label, props, value, inputRef, onChange]);
  const handleOpenChange = useCallback(evt => {
    setShowPopover(evt.target.value);
  }, []);
  const handleClick = useCallback(() => {
    setShowPopover(prev => !prev);
  }, []);
  return /*#__PURE__*/_jsx(Popover, Object.assign({
    inlineSize: "400px",
    placement: "right"
  }, popoverProps, {
    open: showPopover,
    content: popoverContent,
    onOpenChange: handleOpenChange,
    "data-test-id": "property-input-text-area-popover",
    children: /*#__PURE__*/_jsx(UIBox, {
      onClick: handleClick,
      children: /*#__PURE__*/_jsx(UITruncateString, {
        "data-test-id": "property-input-text-area-preview",
        tooltip: !showPopover,
        children: value
      })
    })
  }));
};
export default TextAreaPopover;